import { render, staticRenderFns } from "./stream.vue?vue&type=template&id=8c4811e4"
import script from "./stream.vue?vue&type=script&lang=js"
export * from "./stream.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports